module.exports = __webpack_public_path__ + "static/media/PP7-UltraWide.c6c0b5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper7/PP7-UltraWide.png
// module id = 308
// module chunks = 0